/**
 * 全局配置状态管理
 */
import {ref} from 'vue';
import {defineStore} from 'pinia';
import type {GlobalTheme} from 'naive-ui';
import {darkTheme, useOsTheme} from "naive-ui";
import {useStorage} from '@vueuse/core';
import {store} from '@/stores';
import {createThemeColorTokens} from '@/utils';

const osThemeRef = useOsTheme();

export const useGlobalConfigStore = defineStore('global-config', () => {
    /* 主题 */
    const themeLocal = useStorage<IConfig.Theme>("puppy-theme", "lightTheme");
    const getProviderTheme = (): GlobalTheme => <GlobalTheme>(themeLocal.value === 'osTheme' ? (osThemeRef.value === 'dark' ? darkTheme : null) : themeLocal.value === 'lightTheme' ? null : darkTheme);
    const themeLink = {
        'osTheme': {
            next: 'lightTheme',
            prev: 'darkTheme'
        },
        'lightTheme': {
            next: 'darkTheme',
            prev: 'osTheme'
        },
        'darkTheme': {
            next: 'osTheme',
            prev: 'lightTheme'
        }
    }
    const setTheme = () => {
        const current = themeLocal.value || 'darkTheme';
        const next = <IConfig.Theme>themeLink[current].next;
        themeLocal.value = next;
    }

    /* i18n */
    const localeLocal = useStorage<IConfig.Locale>("puppy-locale", "zh-CN");
    const setLocaleLocal = (local: IConfig.Locale) => {
        localeLocal.value = local;
    }

    /* 主色 */
    const mainColor = useStorage<IConfig.Color>("puppy-main-color-v2", {
        "CMYK": [83, 52, 0, 14],
        "RGB": [38, 105, 220],
        "hex": "#2669dc",
        "hexHover": "#4d8be8",
        "hexPressed": "#0a328f",
        "hexSuppl": "#164bb5",
        "name": "\u9e23\u7fe0\u67f3",
        "pinyin": "mingcuiliu"
    });
    const setPrimaryColor = (color: IConfig.Color) => {
        const tokens = createThemeColorTokens(color);

        // 派生色统一由 theme-token 工具计算，保证与 CSS 变量注入器使用同一套规则。
        color.hexHover = tokens.hover;
        color.hexSuppl = tokens.suppl;
        color.hexPressed = tokens.pressed;

        mainColor.value = color;
    }

    /* 全局Loading */
    const loading = ref(false);
    const loadingText = ref("");

    return {
        theme: themeLocal,
        locale: localeLocal,
        mainColor,
        loading,
        loadingText,
        getProviderTheme,
        setTheme,
        setLocale: setLocaleLocal,
        setPrimaryColor
    }
});

// setup 之外使用
export function useGlobalConfigStoreWithOut() {
    return useGlobalConfigStore(store);
}